import React from 'react';
import { useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';

import Avatar from '@src/components/Avatar';
import Touchable from '@src/components/Touchable';
import { Body1 } from '@src/components/Typography';
import { Rank } from '@src/types';

type Props = {
  item?: Rank;
  index: number;
  size: number;
};

const Container = styled.View`
  align-items: center;
`;

const Component: React.FC<Props> = ({ item, index, size }) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(() => {
    if (item) {
      // @ts-ignore
      navigation.push('Profile', { id: item.user.id });
    }
  }, [item, navigation]);

  if (!item) {
    return null;
  }

  return (
    <Touchable onPress={handlePress}>
      <Container>
        <Body1>{index}</Body1>
        <Avatar source={item.user.avatar} size={size} />
        <Body1>{item.score}</Body1>
      </Container>
    </Touchable>
  );
};

Component.displayName = 'RankAvatar';

export default React.memo(Component);
